import { Button } from '@/components/ui/button'
import { Search } from 'lucide-react'

interface SearchEmptyStateProps {
  searchText: string
  onClearSearch: () => void
  resourceType?: string
  minHeight?: string
}

export function SearchEmptyState({
  searchText,
  onClearSearch,
  resourceType = 'results',
  minHeight = 'min-h-[300px]',
}: SearchEmptyStateProps) {
  return (
    <div className={`flex ${minHeight} items-center justify-center`}>
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
          <Search className="h-8 w-8 text-gray-400" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-black">
          No {resourceType} found
        </h2>
        <p className="mb-4 text-sm text-[#666666]">
          No {resourceType} match "
          <span className="font-medium">{searchText}</span>". Try a different
          search term.
        </p>
        <Button variant="outline" onClick={onClearSearch} size="sm">
          Clear search
        </Button>
      </div>
    </div>
  )
}
